export default __webpack_public_path__ + "static/media/Search.0f265303.png";